export const procedimientoModel = {
  pr: null,
  cp: null,
  np: null,
  dp: null,
  lp: [],
  st: false,
  gc: true,
};
